import React from "react";

import SectionFigure from "./SectionFigure";

export default function NextSection(props) {
  return (
    <>
      <section className="section-spacing" id={props.sectionID}>
        <div className="container">
          <h2 className="heading-secondary">{props.sectionHeading}</h2>

          <div className="container-figure">
            <div className="grid grid--2-cols grid--2-rows">
              <SectionFigure
                heading="The Jay Store"
                listItem1="A store that sells a vast selection of products"
                listItem2="A user-friendly interface with ease of navigation"
                listItem3="Trying to build a long-term relationships with you"
                // popupHeading="Under Maintenance"
                popupHeading="The Jay Store says ..."
                popupBody="Stay tuned, we will be back soon!!"
                popupBackColor="#c30010"
                popupColorR={195}
                popupColorG={0}
                popupColorB={16}
                appURL="/"
              />
              <SectionFigure
                figGridPlacement="row-2--col-2"
                heading="Codebloggers"
                listItem1="A place where computer enthusiasts can share their insights"
                listItem2="Featuring collections of articles of computer coding"
                listItem3="An excellent resource to improve   coding skills"
                appURL="https://jayant-codebloggers.netlify.app/"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
